import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

export default function InsufficientCreditsModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({ required: 0, balance: 0 });

  useEffect(() => {
    const handler = (e) => {
      const d = e.detail || {};
      setInfo({ required: d.required || 0, balance: d.balance || 0 });
      setOpen(true);
    };
    window.addEventListener('photoplan:insufficient-credits', handler);
    return () => window.removeEventListener('photoplan:insufficient-credits', handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="w-5 h-5 text-amber-500" />
            {t('credits.insufficient.title')}
          </DialogTitle>
          <DialogDescription>
            {t('credits.insufficient.body', { required: info.required, balance: info.balance })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setOpen(false)}>
            {t('credits.insufficient.later')}
          </Button>
          <Button
            onClick={() => {
              setOpen(false);
              navigate('/pricing');
            }}
          >
            {t('credits.insufficient.upgrade')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
